import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useProposalStatuses = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'proposal_status',
    gqlEntityKey: 'proposal_status',
    queryName: 'GET_PROPOSAL_STATUSES_QUERY',
    createMutation: 'CREATE_PROPOSAL_STATUS_MUTATION',
    updateMutation: 'UPDATE_PROPOSAL_STATUS_MUTATION',
    deleteMutation: 'DELETE_PROPOSAL_STATUS_MUTATION',
    updateVariableName: 'set',
    transformData: (proposalStatus) => ({
      ...proposalStatus,
      company_name: proposalStatus.company?.name || `Company ${proposalStatus.company_id}`,
      companyId: proposalStatus.company_id,
      status: proposalStatus.status ? 'active' : 'inactive',
    }),
    transformFormData: (formData) => {
      return {
        name: formData.name,
        description: formData.description || null,
        status: formData.status === 'active' || formData.status === true,
        company_id: formData.companyId,
      };
    },
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useProposalStatuses }; 